const validateCoordinates = (latitude, longitude) => {
  const errors = [];
  // 檢查是否為空
  if (!latitude || !longitude) {
    errors.push('請填寫完整的經緯度資料');
    return {isValid: false, errors};
  }
  // 檢查是否為數字
  if (isNaN(latitude) || isNaN(longitude)) {
    errors.push('經緯度必須是數字');
    return {isValid: false, errors};
  }

  // 轉換為數字
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);

  // 緯度範圍檢查 (-90 到 90)
  if (lat < -90 || lat > 90) {
    errors.push('緯度必須在 -90 到 90 之間');
  }

  // 經度範圍檢查 (-180 到 180)
  if (lng < -180 || lng > 180) {
    errors.push('經度必須在 -180 到 180 之間');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export default validateCoordinates;
